import React, {FC} from "react";
import {useIntl} from "react-intl";
import {PageTitle} from "../../../../_metronic/layout/core";
import ImportRequest from "./ImportRequest";

const ImportRequestWrapper: FC = () => {
  const intl = useIntl();
  const breadcrumbs = [
    {
      title: intl.formatMessage({id: 'MENU.DASHBOARD'}),
      path: '/dashboard',
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.WAREHOUSE'}),
      path: '/warehouse/list',
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    }
  ]

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Nhập hàng ký gửi</PageTitle>
      <ImportRequest/>
    </>
  )
}
export default ImportRequestWrapper;